import portalApi from './portalApi';

const portalInvoiceService = {
  getInvoices: () => portalApi.get('/portal/invoices'),
  getInvoiceDetail: (invoiceId) => portalApi.get(`/portal/invoices/${invoiceId}`),
  getBillingSummary: () => portalApi.get('/portal/invoices/billing-summary'),
  getPaymentLink: (invoiceId) => portalApi.get(`/portal/invoices/${invoiceId}/pay`),
  getPaymentPlan: (invoiceId) => portalApi.get(`/portal/invoices/${invoiceId}/payment-plan`),
};

export default portalInvoiceService;
